import React, { useEffect, useState } from "react";
import { getCountries, setSosDetails } from "../../../AxiosRtk/SosSetting";
import ChooseCountry from "../../modals/ChooseCountry";
import Swal from "sweetalert2";
import useSosSetting from "./useSosSetting";
import { useDispatch, useSelector } from "react-redux";
import useFirebase from "../../../../../useFirebase";
import { setShowMessage } from "../../../AxiosRtk/successMessage";
import { setRuleDataSetUp } from "../../../AxiosRtk/SetRules";
import useLangTranslation from "../../../../customHooks/languageProvider";
import { getAccountDetails } from "../../../AxiosRtk/Settings";

const SosSettings = ({ deviceSelected }) => {
  const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);
  const { appLanguageId } = useSelector(({ misc }) => misc);
  const lang = AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find((item) => item?.id === appLanguageId);
  const dispatch = useDispatch();
  const [countryList, setCountryList] = useState([]);
  const [error, setError] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [countryCodeType, setCountryCodeType] = useState("");
  const [selectedId, setSelectedId] = useState("");
  const [selectedCode, setSelectedCode] = useState("");
  const [input, setInput] = useState({
    phone_code: { value: "", error: "", errValue: "" },
    contact: { value: "", error: "", errValue: "" },
  });
  
  const [sosState, setSosState] = useState({
    secondaryCountryCode: "",
    primaryCountryId: "",
    primaryCountryCode: "",
    secondaryCountryId: "",
    primaryNumber: input.contact.value,
    secondaryNumber: "",
  });

  const [originalSosState, setOriginalSosState] = useState({
    secondaryCountryCode: "",
    primaryCountryId: "",
    primaryCountryCode: "",
    secondaryCountryId: "",
    primaryNumber: input.contact.value,
    secondaryNumber: "",
  });

  const { getLangTranslation } = useLangTranslation();

  const { handleSaveData } = useSosSetting(
    deviceSelected,
    sosState,
    setSosState
  );

  const { getCollectionData } = useFirebase(deviceSelected);

  useEffect(() => {
    if (deviceSelected) {
      getCollectionData(deviceSelected);
    } else {
      dispatch(setRuleDataSetUp(null));
    }
  }, [deviceSelected]);

  const { setRulesData } = useSelector(({ setRules }) => setRules);

  useEffect(() => {
    if (setRulesData && setRulesData?.sossettings) {
      setSosState({
        secondaryCountryCode:
          setRulesData?.sossettings?.newPhoneCodeSecondarySos,
        primaryCountryId: setRulesData?.sossettings?.countryCode,
        primaryCountryCode: setRulesData?.sossettings?.newPhoneCodePrimarySos,
        secondaryCountryId: setRulesData?.sossettings?.countryCodeSecondarySos,
        primaryNumber: setRulesData?.sossettings?.phone_no,
        secondaryNumber: setRulesData?.sossettings?.phone_no2,
      });
      setOriginalSosState({
        secondaryCountryCode:
          setRulesData?.sossettings?.newPhoneCodeSecondarySos,
        primaryCountryId: setRulesData?.sossettings?.countryCode,
        primaryCountryCode: setRulesData?.sossettings?.newPhoneCodePrimarySos,
        secondaryCountryId: setRulesData?.sossettings?.countryCodeSecondarySos,
        primaryNumber: setRulesData?.sossettings?.phone_no,
        secondaryNumber: setRulesData?.sossettings?.phone_no2,
      });
    } else {
      setSosState({
        secondaryCountryCode: "",
        primaryCountryId: "",
        primaryCountryCode: "",
        secondaryCountryId: "",
        primaryNumber: "",
        secondaryNumber: ""
      });
      setOriginalSosState({
        secondaryCountryCode: "",
        primaryCountryId: "",
        primaryCountryCode: "",
        secondaryCountryId: "",
        primaryNumber: "",
        secondaryNumber: ""
      });
    }
  }, [setRulesData]);

  useEffect(() => {
    getCountries({
      translation_id: 1,
    }).then((res) => {
      if (res?.data?.status) {
        setCountryList(res?.data?.result);
      }
    });
  }, []);

  useEffect(() => {
    getAccountDetails()
      .then((res) => {
        const data = res?.data?.result[0];
        setInput({
          phone_code: { value: data?.phone_code, error: "" },
          contact: { value: data?.phone_no, error: "" },
        });
      })
      .catch((error) => {
        console.log(
          "get acc details catch error ==>>",
          error?.response?.data?.message
        );
      });
  }, []);

  const closeModal = () => {
    setShowModal(false);
  };

  const openModal = () => {
    setShowModal(true);
  };

  const handleCountryCodeSelection = (codeFor) => {
    setCountryCodeType(codeFor);
    openModal();
  };

  const phoneNumberHandler = (e) => {
    setError([]);
    const { name, value } = e.target;
    setSosState({ ...sosState, [name]: value.replace(/[^0-9]/g, "") });
  };

  const handleCountryCodeSelector = () => {
    closeModal();

    if (countryCodeType === "primary") {
      setSosState({
        ...sosState,
        primaryCountryCode: selectedCode,
        primaryCountryId: selectedId,
      });
    }
    if (countryCodeType === "secondary") {
      setSosState({
        ...sosState,
        secondaryCountryCode: selectedCode,
        secondaryCountryId: selectedId,
      });
    }
  };

  const validate = () => {
    let errArr = [];
    const {
      secondaryCountryCode,
      primaryCountryCode,
      primaryNumber,
      secondaryNumber,
    } = sosState;
    if (primaryNumber?.length < 4 || primaryNumber?.length > 12) {
      errArr.push({
        id: "primaryNumber",
        message: "PHONE_MUST_BE_CORRECT",
        tranlation: "Please enter a valid phone number"
      });
    }
    if (secondaryNumber?.length < 4 || secondaryNumber?.length > 12) {
      errArr.push({
        id: "secondaryNumber",
        message: "PHONE_MUST_BE_CORRECT",
        tranlation: "Please enter a valid phone number"
      });
    }
    if (!primaryCountryCode) {
      errArr.push({
        id: "primaryCode",
        message: "SIGNUP_SELECT_COUNTRY",
        translation: "Select Country"
      });
    }
    if (!secondaryCountryCode) {
      errArr.push({
        id: "secondaryCode",
        message: "SIGNUP_SELECT_COUNTRY",
        translation: "Select Country"
      });
    }
    setError(errArr);
    return errArr.length === 0;
  };

  const handleSubmit = () => {
    const req = {
      countryCode: sosState?.primaryCountryId,
      countryCodeSecondarySos: sosState?.secondaryCountryId,
      newPhoneCodePrimarySos: sosState?.primaryCountryCode,
      newPhoneCodeSecondarySos: sosState?.secondaryCountryCode,
      phone_no: sosState?.primaryNumber,
      phone_no2: sosState?.secondaryNumber,
    };

    if (!validate()) return;

    setSosDetails(req)
      .then((response) => {
        if (response) {
          dispatch(
            setShowMessage({
              showMessage: true,
              defaultMessage: response?.data?.message,
              message: response?.data?.message,
            })
          );

          handleSaveData(req);
        }
      })
      .catch((error) => console.error(`Error:${error}`));
  };

  const showError = (key) => {
    const err = error?.filter((err) => err.id === key);
    return getLangTranslation(err[0]?.message, err[0]?.tranlation);
  };

  // Compare current state with the original state to enable/disable Save
  useEffect(() => {
    const isChanged = JSON.stringify(sosState) !== JSON.stringify(originalSosState);
    setIsSaveDisabled(!isChanged); // Enable Save button if there are changes
  }, [sosState, originalSosState]);

  const [isSaveDisabled, setIsSaveDisabled] = useState(true); // Save button is disabled initially

  if(!deviceSelected) {
    return (
      <div className="text-center my-3">
        -- {getLangTranslation("DEVICE_NOT_SELECTED", "Device not selected")} --
      </div>
    )
  }

  return (
    <>
      <ChooseCountry
        showModal={showModal}
        closeModal={closeModal}
        countryCodeType={countryCodeType}
        countryList={countryList}
        selectedId={selectedId}
        setSelectedCode={setSelectedCode}
        setSelectedId={setSelectedId}
        handleSave={handleCountryCodeSelector}
      />
      <div
        className="alert alert-success alert-dismissible fade show d-flex align-items-center gap-3 mb-6 fw-semibold"
        role="alert"
      >
        <i className="icon-info-one fs-5" />
        {getLangTranslation("SOS_SETTING_DESCRIPTION", "To allow your child send SOS Alerts, you need to add your phone numbers here.")} {getLangTranslation("SOS_SETTING_YOU_CAN_ADD_TWO_NUMBER", "You can add up to two numbers")}
      </div>

      <div className="row gx-3">
        <div className="col-auto flex-grow-1">
          <label htmlFor="fullName" className="form-label text-uppercase text-gray">
            {getLangTranslation("SOS_SETTING_SOS_PRIMARY_NUMBER", "SOS Primary number")}
          </label>
          <div className="d-flex">
            <span className={`icon-wrap icon-blue  ${lang?.isRTL === 1 ? 'ms-3' : 'me-3'}`} style={{flex: '0 0 auto', width: 46, height: 46}}>
              <i className="icon-mobile"></i>
            </span>
            <input
              value={`+ ${sosState?.primaryCountryCode}`}
              onClick={() => handleCountryCodeSelection("primary")}
              type="text"
              style={{ flex: "0 0 80px" }}
              className={`form-control form-control-solid rounded-0 ${lang?.isRTL === 1 ? 'rounded-end ' : 'rounded-start'}`}
            />
            <input
              name="primaryNumber"
              value={input?.contact?.value}
              type="text"
              onChange={phoneNumberHandler}
              className={`form-control form-control-solid text-capitalize rounded-0 $  ${lang?.isRTL === 1 ? 'rounded-start ' : 'rounded-end '}`}
            />
          </div>
          <p className="text-danger">
            {showError(`primaryCode`) ? showError(`primaryCode`) : null}
          </p>
          <p className="text-danger">
            {showError(`primaryNumber`) ? showError(`primaryNumber`) : null}
          </p>
        </div>
        <div className="col-auto flex-grow-1">
          <label htmlFor="fullName" className="form-label text-uppercase text-gray">
            {getLangTranslation("SOS_SETTING_SOS_SECONDARY_NUMBER", "SOS Secondary number")}
          </label>
          <div className="d-flex align-items-start">
            <span className={`icon-wrap icon-blue  ${lang?.isRTL === 1 ? 'ms-3' : 'me-3'}`} style={{flex: '0 0 auto', width: 46, height: 46}}>
              <i className="icon-mobile"></i>
            </span>
            <input
              value={`+ ${sosState?.secondaryCountryCode}`}
              onClick={() => handleCountryCodeSelection("secondary")}
              type="text"
              style={{ flex: "0 0 80px" }}
              className={`form-control form-control-solid rounded-0 ${lang?.isRTL === 1 ? 'rounded-end ' : 'rounded-start'}`}
            />
            <input
              name="secondaryNumber"
              value={sosState?.secondaryNumber}
              onChange={phoneNumberHandler}
              type="text"
              className={`form-control form-control-solid text-capitalize rounded-0  ${lang?.isRTL === 1 ? 'rounded-start ' : 'rounded-end '}`}
            />
            <button type="submit" className={`btn btn-primary ${lang?.isRTL === 1 ? 'me-3' : 'ms-3'}`} onClick={handleSubmit} disabled={isSaveDisabled}>
              <span className="btn-upper-case">{getLangTranslation('SAVE', 'Save')}</span>
            </button>
          </div>
          <p className="text-danger">
            {showError(`secondaryCode`) ? showError(`secondaryCode`) : null}
          </p>
          <p className="text-danger">
            {showError(`secondaryNumber`) ? showError(`secondaryNumber`) : null}
          </p>
        </div>
      </div>
    </>
  );
};

export default SosSettings;
